// ===== BrickMaster Toys — Shopify theme JS =====
document.addEventListener('DOMContentLoaded', () => {
  const overlay   = document.getElementById('cart-overlay');
  const drawer    = document.getElementById('cart-drawer');
  const toggle    = document.getElementById('cart-toggle');
  const closeBtn  = document.getElementById('cart-close');
  const itemsEl   = document.getElementById('cart-items');
  const countEl   = document.getElementById('cart-count');
  const navToggle = document.getElementById('nav-toggle');
  const header    = document.getElementById('SiteHeader');

  function openCart(){ overlay.classList.add('on'); drawer.classList.add('on'); }
  function closeCart(){ overlay.classList.remove('on'); drawer.classList.remove('on'); }

  toggle && toggle.addEventListener('click', openCart);
  closeBtn && closeBtn.addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);

  if (navToggle && header) {
    navToggle.addEventListener('click', () => {
      const open = header.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        header.classList.remove('search-open');
        searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('click', (e) => {
      if (header.classList.contains('nav-open') && !header.contains(e.target)) {
        header.classList.remove('nav-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  const searchToggle = document.getElementById('search-toggle');
  if (searchToggle && header) {
    searchToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = header.classList.toggle('search-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        header.classList.remove('nav-open');
        navToggle && navToggle.setAttribute('aria-expanded', 'false');
        const input = document.getElementById('search-input');
        setTimeout(() => input && input.focus(), 50);
      }
    });
    document.addEventListener('click', (e) => {
      if (header.classList.contains('search-open') && !header.contains(e.target)) {
        header.classList.remove('search-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.BM && window.BM.currency) || 'GBP' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function renderCartDrawer(cart) {
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => {
      const variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="p mono">${escapeHtml(item.variant_title)}</div>`
        : '';
      const thumb = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2') : '';
      return `
        <div class="ci" data-key="${item.key}">
          <div class="thumb"><img src="${thumb}" alt="${escapeHtml(item.product_title)}" width="64" height="64"></div>
          <div class="info">
            <b>${escapeHtml(item.product_title)}</b>
            ${variantLine}
            <div class="p mono">${formatMoney(item.final_line_price)}</div>
            <div class="qty">
              <button type="button" class="qty-minus" data-key="${item.key}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" class="qty-plus" data-key="${item.key}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <button type="button" class="rm" data-key="${item.key}" aria-label="Remove ${escapeHtml(item.product_title)} from cart">Remove</button>
        </div>`;
    }).join('');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  const subEl = document.querySelector('.cart-foot .sub span:last-child');

  // Cart drawer row enter animation (Anime.js). `renderCartDrawer` always
  // fully replaces itemsEl's innerHTML (simplest correct render given how
  // small this cart usually is), so a genuinely new line item can't
  // transition in on its own the way a real DOM insert would — instead we
  // snapshot which keys existed right before the mutating request, diff
  // against what's there after `refreshCart()` re-renders, and only the
  // keys that are actually new get animated in from a hidden inline start
  // state. Existing rows whose quantity merely changed are untouched here.
  function currentCartKeys() {
    return new Set(Array.from(itemsEl ? itemsEl.querySelectorAll('.ci') : []).map((el) => el.dataset.key));
  }
  function animateEnter(keys) {
    if (!window.Anime || !window.Anime.animate) return;
    keys.forEach((key) => {
      const row = itemsEl && itemsEl.querySelector(`.ci[data-key="${key}"]`);
      if (!row) return;
      row.style.opacity = '0';
      row.style.transform = 'translateX(12px)';
      window.Anime.animate(row, { opacity: { to: 1 }, translateX: { to: 0 }, duration: 220, ease: 'outQuad' });
    });
  }

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (countEl) countEl.textContent = cart.item_count;
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    renderCartDrawer(cart);
    return cart;
  }

  // Add to cart. The "added" success state (label swap + pulse) reuses CSS
  // that already existed (.btn-add.added / .product .add.added / .reel-add.added)
  // but was never actually applied by any JS until now.
  function flashAdded(btn) {
    if (btn.dataset.origLabel === undefined) btn.dataset.origLabel = btn.textContent.trim();
    clearTimeout(btn._addedTimer);
    btn.classList.add('added');
    btn.textContent = 'Added ✓';
    if (window.Anime && window.Anime.createTimeline) {
      window.Anime.createTimeline({ defaults: { duration: 175, ease: 'outQuad' } })
        .add(btn, { scale: { to: 1.08 } })
        .add(btn, { scale: { to: 1 } })
        .play();
    }
    btn._addedTimer = setTimeout(() => {
      btn.classList.remove('added');
      btn.textContent = btn.dataset.origLabel;
    }, 1400);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    const beforeKeys = currentCartKeys();
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      await refreshCart();
      const afterKeys = currentCartKeys();
      animateEnter([...afterKeys].filter((k) => !beforeKeys.has(k)));
      flashAdded(btn);
      openCart();
    } catch (err) {
      console.error('Add to cart failed', err);
    } finally {
      btn.disabled = false;
    }
  });

  // Quantity +/- and remove inside the drawer, addressed by line-item key
  document.addEventListener('click', async (e) => {
    const plus = e.target.closest('.qty-plus');
    const minus = e.target.closest('.qty-minus');
    const rm = e.target.closest('.rm');
    if (!plus && !minus && !rm) return;
    const btn = plus || minus || rm;
    if (btn.disabled) return;
    const key = btn.dataset.key;
    const row = document.querySelector(`.ci[data-key="${key}"]`);
    if (!row) return;
    const qtyEl = row.querySelector('.qty span');
    let qty = parseInt(qtyEl.textContent, 10);
    if (plus) qty += 1;
    if (minus) qty = Math.max(0, qty - 1);
    if (rm) qty = 0;

    row.querySelectorAll('button').forEach((b) => { b.disabled = true; });
    const removing = qty === 0;
    if (removing) {
      // Let the row visibly fade/slide out before the drawer re-renders
      // without it, instead of the line just vanishing on the next redraw.
      if (window.Anime && window.Anime.animate) {
        await window.Anime.animate(row, { opacity: { to: 0 }, translateX: { to: 24 }, duration: 180, ease: 'inQuad' });
      } else {
        row.style.transition = 'opacity .18s ease,transform .18s ease';
        row.style.opacity = '0';
        row.style.transform = 'translateX(24px)';
        await new Promise((resolve) => setTimeout(resolve, 180));
      }
    }
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      await refreshCart();
      if (!removing && window.Anime && window.Anime.createTimeline) {
        const newQty = document.querySelector(`.ci[data-key="${key}"] .qty span`);
        if (newQty) {
          window.Anime.createTimeline({ defaults: { duration: 140, ease: 'outQuad' } })
            .add(newQty, { scale: { to: 1.35 } })
            .add(newQty, { scale: { to: 1 } })
            .play();
        }
      }
    } catch (err) {
      console.error('Cart update failed', err);
      row.querySelectorAll('button').forEach((b) => { b.disabled = false; });
      row.style.opacity = '';
      row.style.transform = '';
    }
  });

  // Product filter chips (any section with [data-filter-bar] + [data-filter-grid])
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-filter-bar] .chip');
    if (!chip) return;
    const bar = chip.closest('[data-filter-bar]');
    const section = bar.closest('.section');
    const grid = section && section.querySelector('[data-filter-grid]');
    if (!grid) return;
    bar.querySelectorAll('.chip').forEach((c) => c.classList.remove('active'));
    chip.classList.add('active');
    const filter = chip.dataset.filter;
    grid.querySelectorAll('[data-category]').forEach((item) => {
      item.hidden = !(filter === 'all' || item.dataset.category === filter);
    });
  });

  // Drag-to-scroll for trending reels. `dragged` gates the click that fires on
  // mouseup so a drag that ends over a product card doesn't also navigate to it.
  document.querySelectorAll('[data-reel]').forEach((track) => {
    let isDown = false, startX = 0, scrollL = 0, dragged = false;
    track.addEventListener('mousedown', (e) => {
      isDown = true;
      dragged = false;
      track.classList.add('grabbing');
      startX = e.pageX - track.offsetLeft;
      scrollL = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => { isDown = false; track.classList.remove('grabbing'); });
    track.addEventListener('mouseup', () => { isDown = false; track.classList.remove('grabbing'); });
    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      if (Math.abs(x - startX) > 5) dragged = true;
      track.scrollLeft = scrollL - (x - startX);
    });
    track.addEventListener('click', (e) => {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);
  });

  // Predictive search (always-visible inline search box + results dropdown)
  const searchInput = document.getElementById('search-input');
  const searchDropdown = document.getElementById('search-dropdown');

  if (searchInput && searchDropdown) {
    document.addEventListener('click', (e) => {
      if (!searchDropdown.contains(e.target) && e.target !== searchInput) {
        searchDropdown.classList.remove('on');
      }
    });
    let searchTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchDropdown.classList.remove('on'); searchDropdown.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`);
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            searchDropdown.innerHTML = '<div class="sr-empty">No results found</div>';
          } else {
            searchDropdown.innerHTML = products.map((p) => {
              const tags = p.tags || [];
              let ageBadge = '';
              if (tags.includes('audience:collector')) {
                ageBadge = '<span class="sr-age collector">15+ Collector</span>';
              } else if (tags.includes('age:3-5')) {
                ageBadge = '<span class="sr-age">Ages 3-5</span>';
              } else if (tags.includes('age:6-8')) {
                ageBadge = '<span class="sr-age">Ages 6-8</span>';
              } else if (tags.includes('age:9-12')) {
                ageBadge = '<span class="sr-age">Ages 9-12</span>';
              } else if (tags.includes('age:13-plus')) {
                ageBadge = '<span class="sr-age">Teens+</span>';
              }
              return `
              <a class="sr-item" href="${p.url}">
                <img src="${p.image}" alt="${escapeHtml(p.title)}">
                <span class="sr-meta"><span class="name">${escapeHtml(p.title)}</span>${ageBadge}</span>
                <span class="price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span>
              </a>`;
            }).join('');
          }
          searchDropdown.classList.add('on');
        } catch (err) {
          console.error('Search failed', err);
        }
      }, 200);
    });
  }

  // Header "Shop" mega-dropdown + any other open/close dropdowns
  document.querySelectorAll('.nav-drop').forEach((drop) => {
    const btn = drop.querySelector('.nav-shop-btn');
    const menu = drop.querySelector('.nav-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOn = menu.classList.contains('on');
      document.querySelectorAll('.nav-menu.on').forEach((m) => m.classList.remove('on'));
      document.querySelectorAll('.nav-shop-btn.open').forEach((b) => { b.classList.remove('open'); b.setAttribute('aria-expanded', 'false'); });
      if (!isOn) {
        menu.classList.add('on');
        btn.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('.nav-menu.on').forEach((m) => m.classList.remove('on'));
    document.querySelectorAll('.nav-shop-btn.open').forEach((b) => { b.classList.remove('open'); b.setAttribute('aria-expanded', 'false'); });
  });

  // Floating Lego bricks (cursor-reactive, decorative). Runs unconditionally —
  // including under prefers-reduced-motion — per explicit owner decision
  // (18 Jul 2026, same call as the Phase 22 marquee): the interactive bricks are
  // part of the brand experience and most visitors with the OS flag set never
  // chose it deliberately.
  {
    const canvas = document.createElement('canvas');
    canvas.className = 'floating-bricks';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(canvas, document.body.firstChild);
    const ctx = canvas.getContext('2d');
    let W = 0, H = 0;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      canvas.style.width = W + 'px';
      canvas.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    const COLORS = [
      { fill: '#EC2F3E', stud: '#FF6975', edge: '#A8121F' },
      { fill: '#1FB8E9', stud: '#7FD6F3', edge: '#0E7CAB' },
      { fill: '#FFD83D', stud: '#FFE97A', edge: '#C49600' },
      { fill: '#62C24A', stud: '#92D67E', edge: '#3F8A2C' },
    ];

    function makeBrick(opts) {
      const x = (opts && opts.x !== undefined) ? opts.x : Math.random() * W;
      const y = (opts && opts.y !== undefined) ? opts.y : Math.random() * H;
      return Object.assign({
        x, y, homeX: x, homeY: y, vx: 0, vy: 0,
        rot: Math.random() * Math.PI * 2, restRot: 0, vrot: 0,
        cols: 2, rows: 2, unit: 11, alpha: 1,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        special: false,
      }, opts || {});
    }

    const BRICKS = [];
    const COUNT = 30;
    // Organic scatter: fully random positions with rejection sampling so bricks
    // spread naturally without clumping, instead of the old too-uniform grid.
    function farFromOthers(x, y, minD) {
      return BRICKS.every((b) => {
        const dx = b.homeX - x, dy = b.homeY - y;
        return dx * dx + dy * dy > minD * minD;
      });
    }
    for (let i = 0; i < COUNT; i++) {
      const layout = Math.random();
      const cols = layout < 0.34 ? 2 : (layout < 0.7 ? 4 : 3);
      const rows = (cols === 4) ? 2 : (Math.random() < 0.5 ? 2 : 1);
      let cx, cy, tries = 0;
      do {
        cx = 25 + Math.random() * (W - 50);
        cy = 25 + Math.random() * (H - 50);
        tries++;
      } while (!farFromOthers(cx, cy, 85) && tries < 25);
      const b = makeBrick({ x: cx, y: cy, cols, rows, unit: 7 + Math.random() * 9, color: COLORS[Math.floor(Math.random() * COLORS.length)], restRot: (Math.random() - 0.5) * 0.9 });
      b.rot = b.restRot;
      BRICKS.push(b);
    }
    // Drifters: bricks that sail all the way across the screen left-to-right,
    // separate from the cursor-reactive scattered BRICKS above (never nudged
    // by mouse/touch, never pulled back to a home position). Several run at
    // once, staggered, instead of the original single "speedster".
    const DRIFTER_COUNT = 5;
    const DRIFTERS = [];
    for (let i = 0; i < DRIFTER_COUNT; i++) {
      const vx = 1.4 + Math.random() * 2.2;
      DRIFTERS.push(makeBrick({
        x: -200 + (i * (W + 400) / DRIFTER_COUNT),
        y: H * (0.1 + Math.random() * 0.8),
        vx, vy: (Math.random() - 0.5) * 0.4,
        rot: 0, vrot: (Math.random() - 0.5) * 0.03,
        cols: [2, 3, 4][Math.floor(Math.random() * 3)],
        rows: Math.random() < 0.5 ? 2 : 1,
        unit: 10 + Math.random() * 8,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        special: true,
      }));
    }

    let mx = -9999, my = -9999;
    window.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });
    window.addEventListener('mouseout', (e) => { if (!e.relatedTarget) { mx = -9999; my = -9999; } });
    window.addEventListener('touchmove', (e) => { if (e.touches[0]) { mx = e.touches[0].clientX; my = e.touches[0].clientY; } }, { passive: true });

    // Sitewide content guard: never render a brick over any real content —
    // text or otherwise. The canvas is position:fixed/viewport-relative,
    // matching getBoundingClientRect(), so no coordinate conversion is
    // needed. Rects are refreshed on resize/scroll (rAF-throttled) plus a
    // cheap interval fallback for anything that shifts layout without firing
    // either (dropdowns, cart drawer, async content).
    // History: v1 (headings/paragraphs only) missed images; v2 added img but
    // still missed the "Add to cart" button and the price span, neither a
    // heading nor a paragraph; v3 enumerated a broader tag list (span,
    // button, a, label, input) but STILL missed the "Free UK shipping on all
    // orders" banner, because that text sits directly inside a plain <div>
    // with no wrapping tag at all — proving tag enumeration can never be
    // complete, since real content can live in literally any element.
    // This version drops the tag list entirely and instead asks the only
    // question that actually matters: does this element directly contain
    // visible text (a non-whitespace text node as its own child, not just
    // somewhere in its descendants — that would flag every ancestor wrapper
    // too)? That covers every current and future div/span/heading/whatever
    // automatically. Images, buttons, links and form controls are also
    // always included even when they carry no direct text of their own
    // (an <img> has none by definition; an icon-only button's text can sit
    // in a nested span, in which case the *button's* own full clickable
    // area — padding included — should still stay covered, not just the
    // inner text sliver).
    let textRects = [];
    const TEXT_PAD = 10;
    const ALWAYS_GUARD = 'img, button, a, input, select, textarea';
    function hasDirectText(el) {
      const kids = el.childNodes;
      for (let i = 0; i < kids.length; i++) {
        const n = kids[i];
        if (n.nodeType === 3 && n.textContent.trim().length > 0) return true;
      }
      return false;
    }
    function refreshTextRects() {
      const rects = [];
      const all = document.querySelectorAll('*');
      for (let i = 0; i < all.length; i++) {
        const el = all[i];
        if (el.tagName === 'CANVAS' || el.closest('.floating-bricks')) continue;
        if (!el.matches(ALWAYS_GUARD) && !hasDirectText(el)) continue;
        const r = el.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) continue;
        if (r.bottom < 0 || r.top > H || r.right < 0 || r.left > W) continue;
        rects.push({ left: r.left - TEXT_PAD, right: r.right + TEXT_PAD, top: r.top - TEXT_PAD, bottom: r.bottom + TEXT_PAD });
      }
      textRects = rects;
    }
    refreshTextRects();
    window.addEventListener('resize', refreshTextRects);
    let textRectsScrollQueued = false;
    window.addEventListener('scroll', () => {
      if (textRectsScrollQueued) return;
      textRectsScrollQueued = true;
      requestAnimationFrame(() => { refreshTextRects(); textRectsScrollQueued = false; });
    }, { passive: true });
    setInterval(refreshTextRects, 500);

    function circleIntersectsRect(cx, cy, r, rect) {
      const closestX = Math.max(rect.left, Math.min(cx, rect.right));
      const closestY = Math.max(rect.top, Math.min(cy, rect.bottom));
      const dx = cx - closestX, dy = cy - closestY;
      return (dx * dx + dy * dy) < (r * r);
    }
    function overlapsText(b) {
      const w = b.cols * b.unit, h = b.rows * b.unit;
      const r = Math.sqrt(w * w + h * h) / 2;
      for (let i = 0; i < textRects.length; i++) {
        if (circleIntersectsRect(b.x, b.y, r, textRects[i])) return true;
      }
      return false;
    }

    function roundRect(x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function drawBrick(b) {
      const w = b.cols * b.unit, h = b.rows * b.unit;
      ctx.save();
      ctx.globalAlpha = b.alpha !== undefined ? b.alpha : 1;
      ctx.translate(b.x, b.y);
      ctx.rotate(b.rot);
      ctx.fillStyle = 'rgba(14,58,95,0.16)';
      roundRect(-w / 2 + 3, -h / 2 + 4, w, h, 4);
      ctx.fill();
      ctx.fillStyle = b.color.fill;
      ctx.strokeStyle = b.color.edge;
      ctx.lineWidth = 1.4;
      roundRect(-w / 2, -h / 2, w, h, 4);
      ctx.fill(); ctx.stroke();
      ctx.fillStyle = 'rgba(255,255,255,0.18)';
      roundRect(-w / 2 + 2, -h / 2 + 2, w - 4, h * 0.22, 3);
      ctx.fill();
      const sr = b.unit * 0.28;
      for (let c = 0; c < b.cols; c++) {
        for (let r2 = 0; r2 < b.rows; r2++) {
          const sx = -w / 2 + (c + 0.5) * b.unit;
          const sy = -h / 2 + (r2 + 0.5) * b.unit;
          ctx.beginPath();
          ctx.arc(sx, sy, sr, 0, Math.PI * 2);
          ctx.fillStyle = b.color.stud;
          ctx.fill();
          ctx.strokeStyle = b.color.edge;
          ctx.lineWidth = 1;
          ctx.stroke();
          ctx.beginPath();
          ctx.arc(sx - sr * 0.34, sy - sr * 0.34, sr * 0.34, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255,255,255,0.65)';
          ctx.fill();
        }
      }
      ctx.restore();
    }

    function tick() {
      ctx.clearRect(0, 0, W, H);
      BRICKS.forEach((b) => {
        if (b.special) return;
        const dx = b.x - mx, dy = b.y - my;
        const d2 = dx * dx + dy * dy;
        const R = 220;
        if (d2 < R * R && d2 > 1) {
          const d = Math.sqrt(d2);
          const force = (1 - d / R) * 2.4;
          b.vx += (dx / d) * force;
          b.vy += (dy / d) * force;
          b.vrot += (Math.random() - 0.5) * 0.02;
        }
        const hx = b.homeX - b.x, hy = b.homeY - b.y;
        b.vx += hx * 0.012;
        b.vy += hy * 0.012;
        b.vrot += (b.restRot - b.rot) * 0.01;
        b.vx *= 0.92; b.vy *= 0.92; b.vrot *= 0.92;
        b.x += b.vx; b.y += b.vy; b.rot += b.vrot;
      });
      DRIFTERS.forEach((d) => {
        d.x += d.vx; d.y += d.vy; d.rot += d.vrot;
        if (d.x > W + 200) {
          d.x = -200;
          d.y = H * (0.1 + Math.random() * 0.8);
          d.vx = 1.4 + Math.random() * 2.2;
          d.vy = (Math.random() - 0.5) * 0.4;
          d.color = COLORS[Math.floor(Math.random() * COLORS.length)];
        }
      });
      // Fade in/out near text instead of a hard show/hide cut, which read as
      // a cheap "pop." Alpha eases toward 0/1 each frame rather than
      // snapping, so a brick passing behind a heading or button visibly
      // dissolves and reappears instead of vanishing outright.
      BRICKS.forEach((b) => {
        if (b.special) return;
        const target = overlapsText(b) ? 0 : 1;
        b.alpha += (target - b.alpha) * 0.15;
        if (b.alpha > 0.02) drawBrick(b);
      });
      DRIFTERS.forEach((d) => {
        const target = overlapsText(d) ? 0 : 1;
        d.alpha += (target - d.alpha) * 0.15;
        if (d.alpha > 0.02) drawBrick(d);
      });
    }
    // Driven by Motion's frame loop (rather than a raw requestAnimationFrame
    // call) so this canvas's redraws are batched on the same synced frame as
    // any other Motion-driven animation on the page, instead of running its
    // own independent rAF loop.
    if (window.Motion && window.Motion.frame) {
      window.Motion.frame.render(tick, true);
    } else {
      (function loop() { tick(); requestAnimationFrame(loop); })();
    }

    let lastW = W, lastH = H;
    window.addEventListener('resize', () => {
      BRICKS.forEach((b) => {
        if (b.special) return;
        b.homeX = b.homeX * W / lastW;
        b.homeY = b.homeY * H / lastH;
      });
      lastW = W; lastH = H;
    });
  }

  // Track order modal — decorative/no real order lookup, matches the original
  // Netlify site: it just copies the tracking ID and hands the shopper off to
  // Evri's own tracking page rather than querying any backend.
  const trackModal = document.getElementById('track-modal');
  const trackOverlay = document.getElementById('track-overlay');
  if (trackModal && trackOverlay) {
    const trackMsg = document.getElementById('track-msg');
    function openTrack() {
      trackModal.classList.add('on');
      trackOverlay.classList.add('on');
      trackMsg.style.display = 'none';
      document.getElementById('track-form').reset();
    }
    function closeTrack() {
      trackModal.classList.remove('on');
      trackOverlay.classList.remove('on');
    }
    document.querySelectorAll('.track-order-link').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); openTrack(); }));
    document.getElementById('track-close').addEventListener('click', closeTrack);
    document.getElementById('track-close-2').addEventListener('click', closeTrack);
    trackOverlay.addEventListener('click', closeTrack);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeTrack(); });

    document.getElementById('track-submit').addEventListener('click', () => {
      const email = document.getElementById('track-email').value.trim();
      const tid = document.getElementById('track-id').value.trim();
      if (!email || !tid) {
        trackMsg.style.cssText = 'display:block;background:var(--red-soft);border:2px solid var(--red);border-radius:10px;padding:10px 14px;font-size:13px';
        trackMsg.textContent = 'Please enter both your email and tracking ID.';
        return;
      }
      if (navigator.clipboard) navigator.clipboard.writeText(tid).catch(() => {});
      trackMsg.style.cssText = 'display:block;background:var(--green-soft);border:2px solid var(--green);border-radius:10px;padding:10px 14px;font-size:13px';
      trackMsg.innerHTML = 'Tracking ID <b>' + tid.replace(/</g, '&lt;') + '</b> copied ✔ Opening Evri…';
      setTimeout(() => { window.open('https://www.evri.com/track-a-parcel', '_blank'); closeTrack(); }, 1200);
    });
  }

});

// ===== Review reward reveal (Judge.me) =====
// Shows the REVIEW10 code only after a customer actually submits a review.
// Watches the Judge.me widget for its post-submission confirmation state;
// degrades silently if the widget isn't present or its markup changes.
document.addEventListener('DOMContentLoaded', () => {
  const jdgmWidget = document.getElementById('judgeme_product_reviews');
  if (!jdgmWidget) return;

  let revealed = false;
  function revealReward() {
    if (revealed) return;
    revealed = true;
    const card = document.createElement('div');
    card.className = 'review-reward';
    card.setAttribute('role', 'status');
    card.innerHTML = '<strong>Thank you for your review! 🎉</strong>' +
      '<span>Here\'s 10% off your next order:</span>' +
      '<code class="review-reward-code">REVIEW10</code>' +
      '<small>One use per customer · applies to everything in the shop</small>';
    jdgmWidget.insertAdjacentElement('afterend', card);
    card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  const observer = new MutationObserver(() => {
    // Judge.me swaps the review form for a confirmation notice on submit.
    // Cover the class names their widget has used for that state, plus a
    // text fallback so a class rename degrades to still-working.
    if (jdgmWidget.querySelector('.jdgm-form-submitted, .jdgm-notification, [class*="thank"]')) {
      revealReward();
      observer.disconnect();
      return;
    }
    const notice = [...jdgmWidget.querySelectorAll('div,p,span')].find(
      (el) => /thank you for (your|submitting)/i.test(el.textContent || '')
    );
    if (notice) { revealReward(); observer.disconnect(); }
  });
  observer.observe(jdgmWidget, { childList: true, subtree: true });
});

// ===== Wishlist (localStorage, no app) =====
// Heart buttons on cards/PDP toggle handles in localStorage; the /pages/wishlist
// page renders the list client-side and supports read-only shared views via
// a ?list=handle,handle URL (see sections/main-page-wishlist.liquid).
(function () {
  const WL_KEY = 'bm_wishlist';
  function wlGet() {
    try { const v = JSON.parse(localStorage.getItem(WL_KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function wlSet(list) {
    localStorage.setItem(WL_KEY, JSON.stringify(list));
    refresh();
  }
  function refresh() {
    const list = wlGet();
    const count = document.getElementById('wishlist-count');
    if (count) {
      count.textContent = list.length;
      count.style.display = list.length ? '' : 'none';
    }
    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const active = list.includes(btn.dataset.handle);
      btn.classList.toggle('active', active);
      const label = btn.querySelector('[data-wl-label]');
      if (label) label.textContent = active ? 'In your wishlist ✓' : 'Add to wishlist';
    });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    const h = btn.dataset.handle;
    const list = wlGet();
    wlSet(list.includes(h) ? list.filter((x) => x !== h) : list.concat(h));
  });
  window.bmWishlist = { get: wlGet, set: wlSet, refresh };
  document.addEventListener('DOMContentLoaded', refresh);
})();

// ===== Press feedback (Anime.js spring scale) on interactive controls =====
// A quick scale-down on pointerdown, springing back to 1 on release, layered
// on top of every existing hover/active CSS transition rather than replacing
// it. Delegated on `document` so it works for elements rendered later (cart
// drawer rows, search dropdown results). Falls back to doing nothing if the
// Anime.js CDN import ever fails — the existing CSS :active/:hover states
// still carry the interaction, this is a bonus layer, not the only feedback.
(function () {
  const PRESSABLE = '.btn, .icon-btn, .chip, .cart-btn, .wl-btn, .wl-btn-pdp, ' +
    '[data-add-to-cart], .variant-pill, .band-pill, .submit-btn, .search-go, ' +
    '.qty-plus, .qty-minus, .nav-shop-btn, .hamburger, .rm, .btn-back-float';

  function target(e) {
    const el = e.target.closest(PRESSABLE);
    return (el && !el.disabled) ? el : null;
  }

  // Anime sets an inline `transform` style while animating; if left in
  // place afterward it would permanently outrank the CSS :hover transform
  // rules (e.g. `.btn:hover{transform:translate(-2px,-2px)}`) since inline
  // style always wins over a class selector. Clearing it once the
  // spring-back finishes hands control back to CSS.
  function clearInlineTransform(el) {
    el.style.transform = '';
  }

  // createSpring() returns a reusable pure easing function — build it once
  // rather than on every pointerup.
  let releaseSpring = null;
  function getReleaseSpring() {
    if (!releaseSpring && window.Anime && window.Anime.createSpring) {
      releaseSpring = window.Anime.createSpring({ mass: 1, stiffness: 420, damping: 12 });
    }
    return releaseSpring;
  }

  document.addEventListener('pointerdown', (e) => {
    if (!window.Anime || !window.Anime.animate) return;
    const el = target(e);
    if (!el) return;
    window.Anime.animate(el, { scale: { to: 0.88 }, duration: 90, ease: 'outQuad' });
  });

  function release(e) {
    if (!window.Anime || !window.Anime.animate) return;
    const el = target(e);
    if (!el) return;
    const spring = getReleaseSpring();
    const opts = spring
      ? { scale: { to: 1 }, ease: spring }
      : { scale: { to: 1 }, ease: 'outQuad', duration: 150 };
    const anim = window.Anime.animate(el, opts);
    if (anim && anim.then) anim.then(() => clearInlineTransform(el));
  }
  document.addEventListener('pointerup', release);
  document.addEventListener('pointercancel', release);
  // pointerleave doesn't bubble, so this only works as a capturing listener.
  document.addEventListener('pointerleave', release, true);
})();

// ===== Subtle scroll-reveal for section headings (Anime.js) =====
// Applies sitewide to every existing `.section-head` (kicker + heading pair),
// no markup changes needed in any section file. Deliberately light-touch —
// a small single fade+rise, no per-card stagger, no whole-section reveal —
// after the Phase 64 attempt at whole-section/staggered-card scroll reveals
// was tried and explicitly reverted for feeling "forced." Respects
// prefers-reduced-motion by never hiding content in the first place when the
// user has that flag set (unlike the floating-bricks canvas, this is real
// page content, not a purely decorative background layer). Also does nothing
// if the Anime.js CDN import ever fails — content is never left hidden,
// since the inline hidden style is only applied right before each element
// is actually about to be animated in, not upfront for all of them.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.Anime || !window.Anime.animate) return;
  const heads = document.querySelectorAll('.section-head');
  if (!heads.length || !('IntersectionObserver' in window)) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      window.Anime.animate(entry.target, {
        opacity: { to: 1 }, translateY: { to: 0 }, duration: 350, ease: 'outQuad',
      });
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  heads.forEach((head) => {
    head.style.opacity = '0';
    head.style.transform = 'translateY(14px)';
    io.observe(head);
  });
})();
